import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { BrownfieldFallbackComponent } from 'brownfield-bridge';
import { EntitlementsService } from 'entitlements';
import { adminRoutes } from './admin.routes';

export const measurementStudioRoutes: Route[] = [
  {
    path: 'site-visits',
    redirectTo: '/data-studio/site-visits',
  },
  {
    path: 'analyze/engagement-funnel',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          requireHubReportsAccess: 'app.measurementStudio.accountFunnel',
          requireNotLimitedView: false,
          id: 'account-funnel-measure-studio',
        }),
    ],
    loadChildren: () =>
      import('@features/engagement-funnel').then(
        (m) => m.EngagementFunnelModule,
      ),
  },
  {
    path: 'engagement-spike',
    redirectTo: '/data-studio/engagement-spikes',
  },
  adminRoutes,
  {
    path: '**',
    component: BrownfieldFallbackComponent,
    data: {
      brownfieldRootUrlEnvKey: 'MS_BROWNFIELD_URL',
      brownfieldPathPrefix: 'measure-studio/',
    },
  },
];
